<script lang="ts" setup>
  import type { Golf } from '~/core/types/users'

  import { BngHoles } from '../../holes'
  import { BngCardTopInfos } from '../card-top-infos'

  type Props = {
    golf: Golf
    hasPromotion?: boolean
  }
  const props = defineProps<Props>()

  const services = computed(() => props.golf.services.join(', '))
</script>
<template>
  <NuxtLink
    :to="`/golf/${props.golf.id}`"
    class="c-favorite-golf"
  >
    <bng-card-top-infos
      v-show="hasPromotion"
      main="Promotions disponibles"
      promo
    />
    <div class="picture">
      <img
        :src="props.golf.thumb ?? ''"
        :alt="`${props.golf.id}`"
      >
      <button class="favorite">
        <SvgIcon
          icon="favorite"
          :width="18"
          :height="18"
          :desktop-height="28"
          :desktop-width="28"
        />
      </button>
    </div>
    <div class="content">
      <div class="name">
        <span>{{ props.golf.name }}</span>
      </div>
      <div class="location">
        <span>{{ props.golf.region }}</span>
      </div>
      <div class="detail">
        <span>{{ services }}</span>
      </div>
      <BngHoles
        :model-value="props.golf.holes"
        small
      />
    </div>
  </NuxtLink>
</template>
<style scoped>
.c-favorite-golf {
  position: relative;
  display: flex;
  max-width: 100%;
  flex: 1 1 auto;
  flex-direction: row;
  padding-top: 0.75em;
  border-radius: 0.5rem;

  .picture {
    position: relative;
    display: flex;
    overflow: hidden;
    width: 120px;
    height: 120px;
    flex: 0 0 auto;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background-image: url("https://www.golf-national.com/wp-content/uploads/2016/03/golfnat-7th-front-1024x684.jpg");
    background-position: center;
    background-size: cover;

    img {
      position: relative;
      display: flex;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    button {
      position: absolute;
      display: flex;
      width: 2.125em;
      height: 2.125em;
      align-items: center;
      justify-content: center;
      padding: 0;
      border: none;
      border-radius: 50%;
      background-color: white;
      font-size: 1em;

      .c-icon {
        color: var(--color-primary);
      }
    }
  }

  .content {
    display: flex;
    overflow: hidden;
    flex: 1 1 auto;
    flex-direction: column;
    justify-content: space-between;
    padding: 1em 0 0 1em;

    .name {
      span {
        display: inline-block;
        overflow: hidden;
        width: 100%;
        color: var(--color-secondary);
        font-family: Bariol, sans-serif;
        font-size: 1.25em;
        font-weight: bold;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .location {
      margin-top: 0.25em;
      opacity: 0.8;

      span {
        color: var(--color-secondary);
        font-family: Open-Sans, sans-serif;
        font-size: 0.875em;
        font-weight: 600;
      }
    }

    .detail {
      overflow: hidden;
      flex: 0 1 100%;
      margin-top: 0.25em;
      opacity: 0.6;

      span {
        display: inline-block;
        overflow: hidden;
        width: 100%;
        color: var(--color-secondary);
        font-family: Open-Sans, sans-serif;
        font-size: 0.875em;
        font-weight: normal;
        line-height: initial;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }

    .holes-list {
      display: flex;
      flex-direction: row;
      margin-top: 0.75em;
      opacity: 0.8;

      .holes {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        padding: 0.25em;
        border-radius: 4px;
        background-color: var(--color-secondary-light);

        &:not(:last-child) {
          margin-right: 0.25em;
        }

        span {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          color: var(--color-secondary);
          font-family: Open-Sans, sans-serif;
          font-size: 0.875em;
          font-weight: 600;
          opacity: 0.8;

          .c-icon {
            margin-left: 0.25rem;
          }
        }
      }
    }
  }

  @media screen and (width >= 1024px) {
    padding-top: 1em;

    .c-top-card {
      height: 2em;

      .main {
        padding: 0.25em 0.375em;

        span {
          color: white;
          font-family: Open-Sans, sans-serif;
          font-size: 1.125em;
          font-weight: 600;
        }
      }
    }

    .picture {
      width: 160px;
      height: 160px;

      button {
        width: 3.125em;
        height: 3.125em;
      }
    }

    .content {
      padding-left: 1.25em;

      .name {
        span {
          color: var(--color-secondary);
          font-family: Bariol, sans-serif;
          font-size: 1.625em;
          font-weight: bold;
        }
      }

      .location {
        margin-top: 0.5em;

        span {
          color: var(--color-secondary);
          font-family: Open-Sans, sans-serif;
          font-size: 1.125em;
          font-weight: 600;
        }
      }

      .detail {
        margin-top: 0.5em;

        span {
          color: var(--color-secondary);
          font-family: Open-Sans, sans-serif;
          font-size: 1em;
          font-weight: normal;
        }
      }

      .holes-list {
        .holes {
          min-width: 3.125em;

          span {
            color: var(--color-secondary);
            font-family: Open-Sans, sans-serif;
            font-size: 1.375em;
            font-weight: 600;
          }
        }
      }
    }
  }
}
</style>
